<template>
<div class="clinicReg">
    <vx-card>
        <div class="vx-row" style="margin-left:2%;margin-top:2%;">
            <div class="vx-col w-full md:w-1/2">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Clinic Id</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input type="text" class="w-full" readonly v-model="form.clinicId" />
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Clinic Name</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input type="text" class="w-full" v-model="form.clinicName" name="ClinicName" v-validate="{ required: true,regex: /^[a-zA-Z .'-]+$/}" />
                        <span class="text-danger text-sm" v-show="errors.has('ClinicName')">{{ errors.first('ClinicName') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Area</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                      <select v-model="form.area" class=" vs-select--input myselect" name="Area" style="height: 36px;" v-validate="'required'">
                    <option v-for="(item,index) in areaList" v-bind:key="index" :value="item.id">{{item.name}}</option>
                </select>
                        <!-- <vs-select class="selectExample w-full" v-model="form.area" v-validate="'required'" name="Area">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in areaList" />
                        </vs-select> -->
                        <span class="text-danger text-sm" v-show="errors.has('Area')">{{ errors.first('Area') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Type</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                      <select v-model="form.type" class=" vs-select--input myselect" name="Type" style="height: 36px;" v-validate="'required'" >
                    <option v-for="(item,index) in typeList" v-bind:key="index" :value="item.id">{{item.name}}</option>
                </select>
                        <!-- <vs-select class="selectExample w-full" v-model="form.type" v-validate="'required'" name="Type">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in typeList" />
                        </vs-select> -->
                        <span class="text-danger text-sm" v-show="errors.has('Type')">{{ errors.first('Type') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>PhoneNo</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input type="text" class="w-full" v-validate="'numeric|min:10|max:11'" name="PhoneNumber" v-model="form.phoneNumber" />
                        <span class="text-danger text-sm" v-show="errors.has('PhoneNumber')">{{ errors.first('PhoneNumber') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Map </span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-textarea class="w-full" v-model="form.map" name="Map" />
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Servieces</span>
                    </div>
                    <vs-checkbox v-model="form.onlineBooking">Online Booking</vs-checkbox>
                    <vs-checkbox v-model="form.ivrsService">IVRS</vs-checkbox>
                </div>
            </div>

            <div class="vx-col w-full md:w-1/2 row2">
                <div class="vx-row mb-4">
                    <vs-checkbox v-model="form.status"><span>Active</span></vs-checkbox>
                </div>
                <div class="vx-row mb-4">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Address</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-textarea class="w-full" v-model="form.address" name="Address"  v-validate="{ regex: /^[a-zA-Z0-9 ,./-]+$/}"/>
                        <span class="text-danger text-sm" v-show="errors.has('Address')">{{ errors.first('Address') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>City</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input type="text" class="w-full" v-model="form.city" v-validate="{ regex: /^[a-zA-Z .,/-]+$/}" name="City" />
                        <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>District</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                      <select v-model="form.districtId" class=" vs-select--input myselect" v-validate="'required'" name="District" style="height: 36px;" >
                    <option v-for="(item,index) in districtList" v-bind:key="index" :value="item.id">{{item.name}}</option>
                </select>
                        <!-- <vs-select class="selectExample w-full" v-model="form.district" name="District">
                            <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in districtList" />
                        </vs-select> -->
                        <span class="text-danger text-sm" v-show="errors.has('District')">{{ errors.first('District') }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Pin Code</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <vs-input type="text" class="w-full" v-model="form.pinCode" name="PinCode" v-validate="'numeric|min:6|max:6'" />
                        <span class="text-danger text-sm" v-show="errors.has('PinCode')">{{ errors.first('PinCode') }}</span>
                    </div>
                </div>
            </div>
            <div class="vx-row mb-4">
                <vs-button color="primary" type="border" v-bind:disabled="saveFlag" style="margin-left:530px;margin-top:5%;" @click="saveClinicReg">Save</vs-button>
            </div>
        </div>
        <div>
        </div>
    </vx-card>
</div>
</template>

<script>
export default {
    name: 'doctorMasterReg',
    data() {
        return {
            form: {
                clinicId: "New",
                clinicName: "",
                area: "",
                type: "",
                phoneNumber: "",
                address: "",
                city: "",
                districtId: "",
                pinCode: "",
                map: "",
                onlineBooking: false,
                ivrsService: false,
                status: true,
            },
            districtList: [{
                id: "",
                name: "Select"
            }],
            areaList: [{
                id: "",
                name: "Select"
            }],
            typeList: [{
                id: "",
                name: "Select"
            }],
            saveFlag: false,
        }

    },
    watch: {
        '$route'() {
            if (this.$route.query.clinicId) {
                this.form.clinicId = this.$route.query.clinicId;
            } else {
                this.form.clinicId = 'New';
            }
            if (this.form.clinicId != 'New') {
                this.gePatientDetails();
            }
        }
    },
    beforeMount() {
        if (this.$route.query.clinicId) {
            this.form.clinicId = this.$route.query.clinicId;
            this.getClinicDetails();
        } else {
            this.form.clinicId = 'New';
        }
        this.getClinicLocations();
        this.getClinicTypes();
        this.getDistrictList();
    },
    methods: {
        saveClinicReg() {
            this.form.map = btoa(this.form.map);
            this.$validator.validateAll().then(valid => {
                if (valid) {
                    this.saveFlag = true;
                    this.$vs.loading();
                    this.$http.post(
                            "admin/saveClinic",
                            JSON.stringify(this.form), {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": this.$session.get('adminToken'),
                                    "AdminUserID": this.$session.get('adminId')
                                }
                            }
                        )
                        .then(response => {
                            setTimeout( ()=> {
                                this.$vs.loading.close()
                            }, 300);
                            this.$vs.notify({
                                title: 'Saved Successfully',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                position: 'top-center'
                            });
                            if (!this.$route.query.clinicId) {
                                this.clearForm();
                            } else {
                                this.$router.push({
                                    path: '/admin/clinicDashboard',
                                })
                            }

                        }).catch(error => {
                            setTimeout( ()=> {
                                this.$vs.loading.close()
                            }, 300);
                            this.$vs.notify({
                                title: 'Error Occured While Saving',
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-check',
                                position: 'top-center'
                            })
                            this.saveFlag = false;
                        })
                }
            });
        },
        clearForm() {
            this.form = {
                clinicId: "New",
                clinicName: "",
                area: "",
                type: "",
                phoneNumber: "",
                address: "",
                city: "",
                districtId: "",
                pinCode: "",
                map: "",
                onlineBooking: false,
                ivrsService: false,
                status: true,
            }
             this.$validator.reset();
            this.saveFlag=false;
        },
        getClinicDetails() {
             this.$vs.loading();
            var request = {
                clinicId: this.form.clinicId
            };
            this.$http.post(
                    "admin/getClinicDetails",
                    JSON.stringify(request), {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": this.$session.get('adminToken'),
                            "AdminUserID": this.$session.get('adminId')
                        }
                    }
                )
                .then(response => {
                    setTimeout( ()=> {
                        this.$vs.loading.close()
                    }, 300);
                    this.form = response.data.data;
                    if(response.data.data.map){
                        this.form.map = atob(response.data.data.map);
                    } 
                                      
                })
        },
        getClinicLocations() {
            this.$http.post("admin/getClinicLocations", JSON.stringify(""), {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": this.$session.get('adminToken'),
                        "AdminUserID": this.$session.get('adminId')
                    }
                })
                .then(response => {
                     response.data.data.forEach(element => {
                         this.areaList.push(element);
                     });
                    
                })
        },
        getClinicTypes() {
            this.$http.post("admin/getClinicTypes", JSON.stringify(""), {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": this.$session.get('adminToken'),
                        "AdminUserID": this.$session.get('adminId')
                    }
                })
                .then(response => {
                     response.data.data.forEach(element => {
                         this.typeList.push(element);
                     });
                })
        },
        getDistrictList() {
            this.$http.post("admin/getDistrictList", JSON.stringify(""), {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": this.$session.get('adminToken'),
                        "AdminUserID": this.$session.get('adminId')
                    }
                })
                .then(response => {
                    this.districtList = response.data.data;
                })
        }
    }
}
</script>
